import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLightboard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.1859 21.8141C12.806 22.9537 11.194 22.9537 10.8142 21.8141L8.45531 14.7375C8.42921 14.6592 8.36616 14.5989 8.28682 14.5762L3.47665 13.2019C2.26785 12.8565 2.26785 11.1434 3.47665 10.798L8.28681 9.42371C8.36616 9.40104 8.42921 9.34067 8.45531 9.26238L10.8142 2.1858C11.194 1.04617 12.806 1.04619 13.1859 2.1858L15.5447 9.26239C15.5708 9.34067 15.6339 9.40104 15.7132 9.42371L20.5234 10.798C21.7322 11.1434 21.7322 12.8565 20.5234 13.2019L15.7132 14.5762C15.6339 14.5989 15.5708 14.6592 15.5447 14.7375L13.1859 21.8141ZM12 20.6282L14.1217 14.2632C14.3044 13.7152 14.7457 13.2926 15.3011 13.1339L19.27 11.9999L15.3011 10.866C14.7457 10.7073 14.3044 10.2847 14.1217 9.73673L12 3.37166L9.87833 9.73673C9.69566 10.2847 9.25432 10.7073 8.6989 10.866L4.73006 11.9999L8.6989 13.1339C9.25432 13.2926 9.69566 13.7152 9.87833 14.2632L12 20.6282Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 2.24999C4.91421 2.24999 5.25 2.58577 5.25 2.99999V3.74999H6C6.41421 3.74999 6.75 4.08577 6.75 4.49999C6.75 4.9142 6.41421 5.24999 6 5.24999H5.25V5.99999C5.25 6.4142 4.91421 6.74999 4.5 6.74999C4.08579 6.74999 3.75 6.4142 3.75 5.99999V5.24999H3C2.58579 5.24999 2.25 4.9142 2.25 4.49999C2.25 4.08577 2.58579 3.74999 3 3.74999H3.75V2.99999C3.75 2.58577 4.08579 2.24999 4.5 2.24999Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.25 18C20.25 17.5858 19.9142 17.25 19.5 17.25C19.0858 17.25 18.75 17.5858 18.75 18V18.75H18C17.5858 18.75 17.25 19.0858 17.25 19.5C17.25 19.9142 17.5858 20.25 18 20.25H18.75V21C18.75 21.4142 19.0858 21.75 19.5 21.75C19.9142 21.75 20.25 21.4142 20.25 21V20.25H21C21.4142 20.25 21.75 19.9142 21.75 19.5C21.75 19.0858 21.4142 18.75 21 18.75H20.25V18Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconLightboard as ReactComponent };
